import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CuttingToolCategoryCustomState from "@theStellarBlueprint/Store/Data/CuttingToolCategory/CuttingToolCategoryState";
import { Draft } from "immer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

const initialState = {
    categoryId:""
};
const reducer = {
    "Custom/CuttingToolCategory/Category":(draft:Draft<CuttingToolCategoryCustomState>,action:{categoryId:string},)=>{
        draft.categoryId = action.categoryId
    }
}

export default createTypedReducerWithImmer(initialState,reducer);